<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid ? submit() : ''" ref="form">
                <switch-input label="وضعیت" v-model="form.status"></switch-input>
                <v-text-field
                    :rules="$validation('required')"
                    label="* عنوان"
                    v-model="form.name"
                ></v-text-field>
                <v-autocomplete
                    :items="$system.departments"
                    :rules="$validation('required')"
                    v-model="form.department_id"
                    item-title="name"
                    item-value="id"
                    label="* دپارتمان گیرنده تیکت"
                    no-data-text="موردی پیدا نشد!"
                    @update:modelValue="departmentChange"
                ></v-autocomplete>
                <v-autocomplete
                    :items="ticketCategories"
                    v-model="form.ticket_categories"
                    item-title="name"
                    item-value="id"
                    no-data-text="موردی پیدا نشد!"
                    label="دسته بندی های موضوعی"
                    :disabled="!form.department_id"
                    clearable
                    multiple
                >
                    <template #prepend-item>
                        <toggle-select-all @clicked="$text.toggleSelectAll('form.ticket_categories' , 'ticketCategories', $data)" :items="form.ticket_categories" :all="ticketCategories"></toggle-select-all>
                    </template>
                </v-autocomplete>
                <v-autocomplete
                    :items="services"
                    v-model="form.services"
                    item-title="name"
                    item-value="id"
                    no-data-text="موردی پیدا نشد!"
                    label="سرویس‌ها/محصولات"
                    :disabled="!form.department_id"
                    clearable
                    multiple
                >
                    <template #prepend-item>
                        <toggle-select-all @clicked="$text.toggleSelectAll('form.services' , 'services', $data)" :items="form.services" :all="services"></toggle-select-all>
                    </template>
                </v-autocomplete>
                <v-autocomplete
                    :items="forms"
                    :rules="$validation('required')"
                    v-model="form.form_id"
                    item-title="name"
                    item-value="id"
                    label="* فرم"
                    no-data-text="موردی پیدا نشد!"
                ></v-autocomplete>
                <div class="mt-4">
                    <v-btn type="submit" color="success" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn class="ms-4 " color="error" variant="text" :disabled="loading" @click="$router.push({path: '/settings/ticketForms' })">انصراف</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>

<script>
export default {
    title: "ایجاد",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.custom_field;
    },
    data() {
        return {
            customFields: [],
            loading: false,
            ticketCategories: [],
            services: [],
            forms: [],
            form: {
                status: true,
                name: null,
                description: null,
                department_id: null,
                services: [],
                ticket_categories: []
            }
        };
    },
    methods: {
        departmentChange(value) {
            this.form.ticket_categories = [];
            this.form.services = [];
            this.services = this.$system.services.filter(x => x.departments.find(y => y.id == value));
            this.ticketCategories = this.$system.ticketCategories.filter((x) => x.department_id == value);
            this.ticketCategories.push({name:'سایر',id:'other'})
        },
        submit() {
            this.loading = true;
            let form = JSON.parse(JSON.stringify(this.form));
            if (form.ticket_categories.find((x) => x == "other")) {
                form.ticket_categories.splice(form.ticket_categories.findIndex((x) => x == "other"), 1);
                form.other_ticket_category = true;
            } else form.other_ticket_category = false;
            this.$ticketFormStore(form).then(res => {
                if (res && res.status == 'CREATED') {
                    this.$toast.success(res.message);
                    this.$system.setSystemDefaults(true);
                    this.$router.push({path: '/settings/ticketForms' });
                }
            }).finally(() => this.loading = false);
        },
        async setForms() {
            await this.$formList({page: 1, perPage: 999}).then(res => {
                if (res && res.status == "OK") {
                    this.forms = res.data;
                }
            });
        },
    },
    async mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.setForms();
            this.$loading.finish();
        });
    },
};
</script>
